/* eslint-disable perfectionist/sort-enums */

/** @public */
export enum Apps {
  Max = 'max',
  Media = 'media',
  Creators = 'creators',
  Igloo = 'igloo',
}

/** @public */
export enum Colors {
  Blue = 'blue',
  Yellow = 'yellow',
  Green = 'green',
  Pink = 'pink',
  Purple = 'purple',
}

/** @public */
export enum BooleanValues {
  True = 'true',
  False = 'false',
  Unknown = '',
}

/** @public */
export enum Roles {
  Admin = 'admin',
  Corrector = 'corrector',
  Creator = 'creator',
  Coach = 'coach',
  Member = 'member',
}

/** @public */
export enum Genders {
  Female = 'female',
  Male = 'male',
  Other = 'other',
  Undefined = 'undefined',
  Unknown = 'unknown',
}

/** @public */
export enum Plans {
  Free = 'free',

  Plus = 'plus_monthly',
  Max = 'max_monthly',

  // eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values
  PlusMonthly = 'plus_monthly',
  PlusYearly = 'plus_yearly',
  // eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values
  MaxMonthly = 'max_monthly',
  MaxQuarterly = 'max_quarterly',
  MaxSemestrally = 'max_semestrally',
}

/** ****************************************************************************
 * Media related enums (Creation Engine and app).
 **************************************************************************** */

/** @public */
export enum ObjectFits {
  Contain = 'contain',
  Cover = 'cover',
}

/** @public */
export enum EditionStatuses {
  Draft = 'draft',
  Review = 'review',
  Ready = 'ready',
  Scheduled = 'scheduled',
  Published = 'published',
  Archived = 'archived',
}

/** @public */
export enum AllowedMediaSources {
  Giphy = 'giphy',
  Link = 'link',
  LoremPicsum = 'loremPicsum',
  Unsplash = 'unsplash',
  Upload = 'upload',
  Paste = 'paste',
}

/** @public */
export enum PublicationAudiences {
  AllSubscribed = 'global_newsletter',
  PaidSubscribed = 'only_plus_newsletter',
  FreeSubscribed = 'only_free_newsletter',
  // All = 'all',
  // Paid = 'all_paying',
  // Free = 'all_free',
  Unknown = 'undefined',
}

/** @public */
export enum PublicationModes {
  Media = 'media',
  Inbox = 'inbox',
}
